import { css } from 'lit';
export default css `
  :host {
    display: inline-block;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--amityeko-color-gray-6);
  }
`;
//# sourceMappingURL=styles.js.map